"use client";

import React, { useContext } from "react";

import { LayoutElementProductTileClickProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/LayoutElement/LayoutElementProductTileClickProvider";
import { SearchProductTileClickProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProvider";
import { SearchProductTileClickProviderProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProviderProps";
import { ProductTileType } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { ProductTileTypeContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/productTileTypeContext";

/**
 * In charges of providing everything related to navigate to pdp
 */
export const ProductTileClickContextProvider = ({
  data,
  children,
}: {
  data: SearchProductTileClickProviderProps;
  children: React.ReactNode;
}) => {
  const { productTileType } = useContext(ProductTileTypeContext);

  switch (productTileType) {
    case ProductTileType.LAYOUT_ELEMENT:
      return (
        <LayoutElementProductTileClickProvider data={data}>
          {children}
        </LayoutElementProductTileClickProvider>
      );
    case ProductTileType.SEARCH:
    default:
      return (
        <SearchProductTileClickProvider data={data}>
          {children}
        </SearchProductTileClickProvider>
      );
  }
};
